import React from 'react'
import {Svg, CommonSvgProps, commonPropTypes, commonDefaultProps} from '@modifi/ui'

type CareerIconProps = CommonSvgProps

const CareerIcon: React.FC<CareerIconProps> = React.forwardRef<SVGSVGElement, CareerIconProps>(
  (props, ref) => (
    <Svg viewBox="0 0 120 70" {...props} ref={ref} color="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M89.8335 44.8702C90.4425 45.809 90.7445 46.9544 90.6905 48.1931C90.6212 49.7326 89.9915 51.2272 88.962 52.2925C87.9166 53.3729 86.5209 53.9703 85.0281 53.9703C84.2897 53.9703 83.5684 53.822 82.8978 53.5347C82.8657 54.9515 82.3085 56.3242 81.3148 57.3493C80.2706 58.4297 78.8725 59.0256 77.3809 59.0256C76.476 59.0256 75.5907 58.7986 74.8006 58.3732C74.7206 59.7222 74.1623 61.0209 73.2117 61.9947C72.1674 63.0648 70.7744 63.6547 69.2913 63.6547C68.5726 63.6547 67.8662 63.5142 67.2103 63.2417C67.0353 64.4075 66.504 65.4867 65.6693 66.3398C64.6276 67.4102 63.2358 68 61.7517 68C60.409 68 59.149 67.4931 58.1456 66.6035L27.5564 43.1201C24.6902 40.116 20.0635 35.5058 18.6692 34.5736C17.8148 34.1305 15.85 32.7076 14.8976 32.7076C13.9452 32.7076 25.8911 10.6282 26.1327 10.7474C26.2437 10.7976 29.6007 12.2595 29.7634 12.3361C31.4191 13.1291 34.8646 14.7754 39.1844 14.7754C40.7883 14.7754 42.3674 14.5409 43.88 14.079C47.8804 12.8581 52.4776 11.6084 56.2401 11.6084C58.6046 11.6084 60.4157 12.134 61.6631 13.1568C61.6396 13.1842 61.9152 13.5011 62.4278 14.0194C64.4675 11.6044 66.255 10.7474 68.0278 10.7474C71.2664 10.7474 74.4779 13.538 78.9517 14.9033C80.643 15.419 82.2778 15.6236 83.81 15.6236C88.6905 15.6236 92.5418 13.5545 93.8932 12.9308C94.0631 12.848 96.8294 11.6084 97.0056 11.6084C97.4533 11.6084 107.959 31.8689 107.959 31.8689C106.868 32.7176 104.643 34.0503 104.044 34.3466C102.521 35.3441 97.4621 40.5176 95.0198 43.0035C94.2087 43.8279 93.2656 44.1905 92.2275 44.1905C91.3197 44.1905 90.3377 43.9024 89.3104 43.4048C89.5561 44.1702 89.7236 44.7007 89.8335 44.8702Z"
        stroke="#51565C"
        strokeWidth="3.5"
      />
      <path
        d="M104.628 32.6773L95.5622 13.4975C95.3572 13.0602 94.9276 12.8058 94.4818 12.8058C94.3064 12.8058 94.1307 12.8446 93.9615 12.9273C92.6158 13.5502 88.7808 15.6164 83.9209 15.6164C82.3952 15.6164 80.7672 15.4122 79.0831 14.8972C74.6282 13.5338 71.4302 10.7469 68.2054 10.7469C66.44 10.7469 64.6601 11.6027 62.6664 13.9712C62.54 14.1177 62.4209 14.2507 62.2933 14.4099C58.2618 19.51 51.1099 24.5298 49.5128 25.4884C48.0703 26.3543 46.6931 28.942 48.948 31.2452C50.2468 32.5697 52.3743 33.3254 54.5079 33.3254C56.0828 33.3254 57.6615 32.9131 58.9113 32.0135C66.1725 26.7755 67.8716 23.9335 69.3607 23.9335C70.08 23.9335 70.7502 24.5951 71.9729 25.9697C75.4544 29.8781 82.0011 38.606 87.6676 42.3589C89.3189 43.4516 90.8998 44.1445 92.3029 44.1445C93.3366 44.1445 94.2757 43.7825 95.0834 42.9592C97.5153 40.4767 102.553 35.3102 104.069 34.314C104.666 34.0181 104.918 33.2865 104.628 32.6773"
        stroke="#51565C"
        strokeWidth="3.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M106.304 4.49464C106.014 3.87516 105.293 3.61977 104.698 3.92248L93.7889 9.4659C93.1936 9.76861 92.9465 10.516 93.2381 11.1354L104.812 35.6983C105.102 36.3165 105.822 36.5731 106.418 36.2706L117.327 30.7269C117.922 30.4241 118.168 29.6768 117.878 29.0586L106.304 4.49464Z"
        fill="white"
        stroke="#51565C"
        strokeWidth="3.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.3014 2.12725C14.7062 1.82467 13.9868 2.07994 13.6953 2.69967L2.12257 27.2639C1.8311 27.8822 2.07712 28.6294 2.67344 28.9321L13.5821 34.4759C14.1774 34.7773 14.8969 34.5219 15.1896 33.9036L26.7623 9.34047C27.0537 8.72098 26.8052 7.97361 26.21 7.6709L15.3014 2.12725Z"
        fill="white"
        stroke="#51565C"
        strokeWidth="3.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M61.9965 55.4846C61.3228 54.8161 60.4404 54.4819 59.5552 54.4819C58.6727 54.4819 57.789 54.8162 57.1154 55.4846L51.9774 60.5743C50.6289 61.91 50.6289 64.0746 51.9774 65.4069C52.6509 66.0753 53.5347 66.4096 54.4173 66.4096C55.2998 66.4096 56.1835 66.0753 56.8571 65.4069L61.9964 60.3198C63.3436 58.984 63.3436 56.8205 61.9965 55.4846"
        fill="white"
      />
      <path
        d="M61.9965 55.4846C61.3228 54.8161 60.4404 54.4819 59.5552 54.4819C58.6727 54.4819 57.789 54.8162 57.1154 55.4846L51.9774 60.5743C50.6289 61.91 50.6289 64.0746 51.9774 65.4069C52.6509 66.0753 53.5347 66.4096 54.4173 66.4096C55.2998 66.4096 56.1835 66.0753 56.8571 65.4069L61.9964 60.3198C63.3436 58.984 63.3436 56.8205 61.9965 55.4846"
        stroke="#51565C"
        strokeWidth="3.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M56.2417 48.5277C55.4772 47.7257 54.4769 47.3253 53.4764 47.3253C52.4748 47.3253 51.4744 47.7257 50.711 48.5277L44.8875 54.6355C43.3595 56.2369 43.3595 58.8338 44.8875 60.4375C45.6509 61.2394 46.6524 61.6386 47.6528 61.6386C48.6532 61.6386 49.6536 61.2394 50.4182 60.4375L56.2417 54.3284C57.7697 52.727 57.7697 50.1298 56.2417 48.5277"
        fill="white"
      />
      <path
        d="M56.2417 48.5277C55.4772 47.7257 54.4769 47.3253 53.4764 47.3253C52.4748 47.3253 51.4744 47.7257 50.711 48.5277L44.8875 54.6355C43.3595 56.2369 43.3595 58.8338 44.8875 60.4375C45.6509 61.2394 46.6524 61.6386 47.6528 61.6386C48.6532 61.6386 49.6536 61.2394 50.4182 60.4375L56.2417 54.3284C57.7697 52.727 57.7697 50.1298 56.2417 48.5277"
        stroke="#51565C"
        strokeWidth="3.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M49.7199 43.0555C48.891 42.1911 47.8032 41.759 46.7152 41.759C45.6285 41.759 44.5406 42.1911 43.7105 43.0555L36.9585 50.0973C35.2996 51.8285 35.2996 54.6337 36.9585 56.3623C37.7886 57.2303 38.8765 57.6626 39.9644 57.6626C41.051 57.6626 42.1389 57.2303 42.969 56.3623L49.7198 49.323C51.3814 47.5931 51.3814 44.788 49.7199 43.0555"
        fill="white"
      />
      <path
        d="M49.7199 43.0555C48.891 42.1911 47.8032 41.759 46.7152 41.759C45.6285 41.759 44.5406 42.1911 43.7105 43.0555L36.9585 50.0973C35.2996 51.8285 35.2996 54.6337 36.9585 56.3623C37.7886 57.2303 38.8765 57.6626 39.9644 57.6626C41.051 57.6626 42.1389 57.2303 42.969 56.3623L49.7198 49.323C51.3814 47.5931 51.3814 44.788 49.7199 43.0555"
        stroke="#51565C"
        strokeWidth="3.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.3399 38.2371C40.5452 37.404 39.5053 36.9879 38.4642 36.9879C37.4243 36.9879 36.3833 37.4039 35.5886 38.2371L30.0759 44.0188C28.4871 45.6854 28.4871 48.3842 30.0759 50.0508C30.8692 50.8851 31.9104 51.3012 32.9516 51.3012C33.9928 51.3012 35.0327 50.885 35.8271 50.0508L41.3398 44.2701C42.9275 42.6025 42.9275 39.9023 41.3399 38.2371"
        fill="white"
      />
      <path
        d="M41.3399 38.2371C40.5452 37.404 39.5053 36.9879 38.4642 36.9879C37.4243 36.9879 36.3833 37.4039 35.5886 38.2371L30.0759 44.0188C28.4871 45.6854 28.4871 48.3842 30.0759 50.0508C30.8692 50.8851 31.9104 51.3012 32.9516 51.3012C33.9928 51.3012 35.0327 50.885 35.8271 50.0508L41.3398 44.2701C42.9275 42.6025 42.9275 39.9023 41.3399 38.2371"
        stroke="#51565C"
        strokeWidth="3.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4583 21.8805L14.8234 23.916L12.807 28.24L8.44194 26.2046L10.4583 21.8805Z"
        fill="#53A2D9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M109.456 23.6453L111.567 27.9741L107.279 30.0657L105.168 25.7368L109.456 23.6453Z"
        fill="#7BB835"
      />
    </Svg>
  )
)

CareerIcon.propTypes = commonPropTypes
CareerIcon.defaultProps = commonDefaultProps

export default CareerIcon
